<ng-container>
    <app-grid-client-side
        #componentsGridComponent
        [headerCheckboxSelection]="true"
        (areRowsSelected)="handleSelectionChange($event)"
        (rowClicked)="rowClicked($event)"
        [hidden]="!gridPath"
        [tableData]="tableData[0]"
        [fixedButtons]="fixedButtons"
        (deleteChange)="deleteComponents($event)"
        (gridReadyEmitter)="onGridReady()"
        (filterChangedEmitter)="onFilterChangedEmitter($event)"
        [exportFormatterOptions]="exportFormatterOptions"
        (clickableAction)="actions($event)"
        feature="components"
    ></app-grid-client-side>
</ng-container>